// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"81bc6697","787":"c1cf3da7"}[chunkId] + ".chunk.js";
};